import i18n from '@/i18n';

function breadcrumbs(route) {
    const mainRoute = route.path;
    const pathArray = mainRoute.split('/');
    pathArray.shift();

    const breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        breadcrumbArray.push({
            path: path,
            to: breadcrumbArray[idx - 1]
                ? '/' + breadcrumbArray[idx - 1].path + '/' + path
                : '/' + path,
            text: i18n.t(
                `breadcrumbs.${
                route.matched[idx].name
                    ? route.matched[idx].name.toLowerCase()
                    : path
                }`,
            ),
            disabled: false,
            activeClass: '',
            exactActiveClass: '',
        });
        return breadcrumbArray;
    }, []);

    return breadcrumbs;
}

export default breadcrumbs;
